<template>
  <header class="app-header">
    <div class="container">
      <div class="top">
        <div class="logo">
          <router-link to="/">
            <img
              v-if="webLogo"
              :src="webLogo"
              :alt="webName"
              :title="webName"
            />
            <img v-else src="../assets/logo.png" alt="" :title="webName" />
          </router-link>
        </div>
        <div class="top_right" v-show="!isSearchOpen">
          <div class="top_right_item" @click="openSearch">
            <div class="top_right_item_icon">
              <img src="../assets/icon0.png" alt="" />
            </div>
            <div class="top_right_item_text">
              <span>搜索</span>
            </div>
          </div>
          <div class="top_right_item qr-item">
            <div class="top_right_item_icon">
              <img src="../assets/icon1.png" alt="" />
            </div>
            <div class="top_right_item_text">
              <span>客户端</span>
            </div>
            <div class="qr-popup">
              <img v-if="webDownloadUrl" :src="webDownloadUrl" alt="APP下载" />
              <div v-else class="qr-placeholder">暂无二维码</div>
            </div>
          </div>
          <div class="top_right_item qr-item">
            <div class="top_right_item_icon">
              <img src="../assets/icon2.png" alt="" />
            </div>
            <div class="top_right_item_text">
              <span>公众号</span>
            </div>
            <div class="qr-popup">
              <img v-if="wxQrUrl" :src="wxQrUrl" alt="公众号" />
              <div v-else class="qr-placeholder">暂无二维码</div>
            </div>
          </div>
          <div class="top_right_item" @click="handleMenuClick('/about-us', 'AboutUs')">
            <div class="top_right_item_icon">
              <img src="../assets/aboutme.png" alt="" />
            </div>
          </div>
          <div
            class="top_right_item"
            @click="isLoggedIn ? handleLogout() : goToLogin()"
          >
            <div class="top_right_item_icon">
              <img src="../assets/icon3.png" alt="" />
            </div>
            <div class="top_right_item_text">
              <span>{{ isLoggedIn ? "退出登录" : "登录" }}</span>
            </div>
          </div>
        </div>
        <!-- 搜索框 -->
        <div class="search-box" v-show="isSearchOpen">
          <div class="search-icon">
            <i class="el-icon-search"></i>
          </div>
          <input
            type="text"
            class="search-input"
            placeholder="您要搜索的内容"
            v-model="searchKeyword"
            @keyup.enter="handleSearch"
            ref="searchInput"
          />
          <button
            class="search-close"
            @click="closeSearch"
            aria-label="关闭搜索"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 4L4 12M4 4L12 12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>
        <button
          class="mobile-menu-toggle"
          @click="toggleMenu"
          aria-label="切换菜单"
          v-show="!isSearchOpen"
        >
          <span class="hamburger-line" :class="{ active: isMenuOpen }"></span>
          <span class="hamburger-line" :class="{ active: isMenuOpen }"></span>
          <span class="hamburger-line" :class="{ active: isMenuOpen }"></span>
        </button>
      </div>
    </div>
    <div class="menu" :class="{ open: isMenuOpen }">
      <div class="container">
        <nav class="menu-nav">
          <router-link to="/" class="menu-item" @click.prevent="handleMenuClick('/', '/')"
            >首页</router-link
          >
          <a
            v-for="item in navList"
            :key="item.id"
            v-show="item.id !== 7"
            :href="getNavHref(item)"
            target="_blank"
            class="menu-item"
            @click="closeMenu"
          >
            {{ item.name }}
          </a>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "AppHeader",
  props: {
    navList: {
      type: Array,
      default: () => [],
    },
    webName: {
      type: String,
      default: "",
    },
    webLogo: {
      type: String,
      default: "",
    },
    webDownloadUrl: {
      type: String,
      default: "",
    },
    wxQrUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isMenuOpen: false,
      isSearchOpen: false,
      searchKeyword: "",
      isLoggedIn: !!localStorage.getItem("token"),
    };
  },
  watch: {
    $route() {
      this.isLoggedIn = !!localStorage.getItem("token");
    },
  },
  methods: {
    handleMenuClick(path, name) {
      window.open(this.$router.resolve({ path, name }).href, '_blank');
      this.closeMenu();
    },
    getNavHref(item) {
      if (item.id == 8) {
        return this.$router.resolve({ name: 'BrandActivity' }).href;
      } else if (item.id == 12) {
        return this.$router.resolve({ name: 'AboutUs' }).href;
      } else {
        return this.$router.resolve({
          name: 'BilingualNews',
          query: {
            categoryId: String(item.id),
            categoryName: item.name,
          },
        }).href;
      }
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    goToLogin() {
      const href = this.$router.resolve('/login').href;
      window.open(href, '_blank');
    },
    handleLogout() {
      localStorage.removeItem("token");
      this.isLoggedIn = false;
      window.open(this.$router.resolve('/login').href, '_blank');
    },
    openSearch() {
      this.isSearchOpen = true;
      this.$nextTick(() => {
        if (this.$refs.searchInput) {
          this.$refs.searchInput.focus();
        }
      });
    },
    closeSearch() {
      this.isSearchOpen = false;
      this.searchKeyword = "";
    },
    handleSearch() {
      if (this.searchKeyword.trim()) {
        // 跳转到搜索页面，并传递搜索关键词
        const href = this.$router.resolve({
          path: "/search",
          query: {
            keyword: this.searchKeyword.trim(),
          },
        }).href;
        window.open(href, '_blank');
        // 关闭搜索框
        this.closeSearch();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.app-header {
  width: 100%;
}

.container {
  max-width: 76rem;
  margin: 0 auto;
  padding: 0 16px 0 0;
  box-sizing: border-box;
}

.top {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  position: relative;

  .logo {
    width: 180px;
    height: 25px;
    flex-shrink: 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .top_right {
    display: flex;
    align-items: center;
    gap: 8px;

    .top_right_item {
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: opacity 0.3s;

      &:hover {
        opacity: 1;
      }

      .top_right_item_icon {
        width: 24px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        flex-shrink: 0;
        img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }
      }

      .top_right_item_text {
        margin-left: 6px;
        display: none;
        span {
          font-family: Adobe Heiti Std;
          font-size: 14px;
          color: #b9b9b9;
          white-space: nowrap;
        }
      }

      &.qr-item {
        position: relative;

        .qr-popup {
          position: absolute;
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          margin-top: 10px;
          background: #fff;
          padding: 10px;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
          border-radius: 4px;
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s;
          z-index: 100;
          white-space: nowrap;

          img {
            max-width: 120px;
            max-height: 120px;
            display: block;
          }

          .qr-placeholder {
            padding: 20px;
            color: #999;
            font-size: 12px;
          }

          &::before {
            content: "";
            position: absolute;
            top: -6px;
            left: 50%;
            transform: translateX(-50%);
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-bottom: 6px solid #fff;
          }
        }

        &:hover .qr-popup {
          opacity: 1;
          visibility: visible;
        }
      }
    }
  }

  .mobile-menu-toggle {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 28px;
    height: 24px;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    z-index: 1001;

    .hamburger-line {
      width: 100%;
      height: 3px;
      background-color: #333;
      border-radius: 2px;
      transition: all 0.3s ease;
      transform-origin: center;

      &.active {
        &:nth-child(1) {
          transform: rotate(45deg) translate(7px, 7px);
        }
        &:nth-child(2) {
          opacity: 0;
        }
        &:nth-child(3) {
          transform: rotate(-45deg) translate(7px, -7px);
        }
      }
    }
  }

  .search-box {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 500px;
    height: 40px;
    background: #ffffff;
    border-radius: 20px;
    padding: 0 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    z-index: 1000;

    .search-icon {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 8px;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .search-input {
      flex: 1;
      border: none;
      outline: none;
      font-size: 14px;
      color: #333;
      background: transparent;

      &::placeholder {
        color: #999;
      }
    }

    .search-close {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 0;
      margin-left: 8px;
      color: #999;
      transition: color 0.3s;

      &:hover {
        color: #333;
      }

      svg {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.menu {
  width: 100%;
  background: #a40d21;
  transition: all 0.3s ease;
  overflow: hidden;
  max-height: 0;
  opacity: 0;

  &.open {
    max-height: 500px;
    opacity: 1;
  }

  .container {
    padding: 0 16px;
  }
}

.menu-nav {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.menu-item {
  padding: 12px 16px;
  font-family: MicrosoftYaHei, "Microsoft YaHei", -apple-system,
    BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif;
  font-size: 14px;
  color: #ffffff;
  text-decoration: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: background 0.3s;
  text-align: left;

  &:last-child {
    border-bottom: none;
  }

  &:hover,
  &:active {
    background: rgba(255, 255, 255, 0.15);
  }
}

// 平板端样式 (768px - 1023px)
@media (min-width: 768px) {
  .container {
    padding: 0 24px 0 0;
  }

  .top {
    padding: 32px 0 24px 0;

    .logo {
      width: 220px;
      height: 31px;
    }

    .top_right {
      gap: 12px;

      .top_right_item {
        .top_right_item_icon {
          width: 28px;
          height: 23px;
        }

        .top_right_item_text {
          display: block;
          margin-left: 6px;
          span {
            font-size: 16px;
          }
        }

        &.qr-item {
          .qr-popup {
            img {
              max-width: 100px;
              max-height: 100px;
            }
          }
        }
      }
    }

    .mobile-menu-toggle {
      display: none;
    }

    .search-box {
      max-width: 600px;
      height: 44px;
      padding: 0 16px;

      .search-icon {
        width: 24px;
        height: 24px;
        margin-right: 12px;
      }

      .search-input {
        font-size: 16px;
      }

      .search-close {
        width: 24px;
        height: 24px;
        margin-left: 12px;
      }
    }
  }

  .menu {
    max-height: none;
    opacity: 1;
  }

  .menu-nav {
    flex-direction: row;
    align-items: center;
    white-space: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
  }

  .menu-item {
    padding: 14px 16px;
    font-size: 12px;
    border-bottom: none;
    flex-shrink: 0;
    text-align: center;
  }
}

// 桌面端样式 (>=1024px)
@media (min-width: 1024px) {
  .container {
    padding: 0 32px 0 0;
  }

  .top {
    padding: 44px 0 28px 0;

    .logo {
      width: 255px;
      height: 36px;
    }

    .top_right {
      gap: 0;

      .top_right_item {
        margin-left: 16px;

        .top_right_item_icon {
          width: 30px;
          height: 25px;
        }

        .top_right_item_text {
          margin-left: 8px;
          span {
            font-size: 18px;
          }
        }

        &.qr-item {
          .qr-popup {
            img {
              max-width: 120px;
              max-height: 120px;
            }
          }
        }
      }
    }
  }

  .menu-nav {
    justify-content: flex-start;
    overflow-x: visible;
  }

  .menu-item {
    padding: 15px 20px;
    font-size: 14px;
  }

  .search-box {
    max-width: 700px;
    height: 48px;
    padding: 0 20px;

    .search-icon {
      width: 28px;
      height: 28px;
      margin-right: 16px;
    }

    .search-input {
      font-size: 18px;
    }

    .search-close {
      width: 28px;
      height: 28px;
      margin-left: 16px;
    }
  }
}
</style>
